module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAAO5JREFUSA3tVksOAjEILcYbuNClC2/k8V14Ae+gAxGCSAk2LBrTbkqZx+NBPxl4nC/Pto3T9YgTDWDn4X5jX9uzBQBsNkLqUPqC4XZQuA5FpCTCxRcNOt/jA6hVMYBnUYkOm45B9I1rjNLudETPFm2RrhSTiI+Ep5hEkxYdVapx1k5ltEG9tass6lyPCP2lyqT7OmO0Expn7VJlbs+m2M3SMkvJ3J5Ncc5Kyywlm/cGlJZZSuaeM/sa4Hr0vnpcGV9plZmEWcwSlu0U49JnbPR940S/zmsr/6Zj7tvvVTf6R+RxZXzrjGW6pDHTduwF/tQ9TUcooSgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Uniited Arab Emirates.png
// module id = 1294
// module chunks = 7